/**
 * DEVELOPER DOCUMENTATION
 *
 * Include your custom JavaScript here.
 *
 * The theme Focal has been developed to be easily extensible through the usage of a lot of different JavaScript
 * events, as well as the usage of custom elements (https://developers.google.com/web/fundamentals/web-components/customelements)
 * to easily extend the theme and re-use the theme infrastructure for your own code.
 *
 * The technical documentation is summarized here.
 *
 * ------------------------------------------------------------------------------------------------------------
 * BEING NOTIFIED WHEN A VARIANT HAS CHANGED
 * ------------------------------------------------------------------------------------------------------------
 *
 * This event is fired whenever a the user has changed the variant in a selector. The target get you the form
 * that triggered this event.
 *
 * Example:
 *
 * document.addEventListener('variant:changed', function(event) {
 *   let variant = event.detail.variant; // Gives you access to the whole variant details
 *   let form = event.target;
 * });
 *
 * ------------------------------------------------------------------------------------------------------------
 * MANUALLY CHANGE A VARIANT
 * ------------------------------------------------------------------------------------------------------------
 *
 * You may want to manually change the variant, and let the theme automatically adjust all the selectors. To do
 * that, you can get the DOM element of type "<product-variants>", and call the selectVariant method on it with
 * the variant ID.
 *
 * Example:
 *
 * const productVariantElement = document.querySelector('product-variants');
 * productVariantElement.selectVariant(12345);
 *
 * ------------------------------------------------------------------------------------------------------------
 * BEING NOTIFIED WHEN A NEW VARIANT IS ADDED TO THE CART
 * ------------------------------------------------------------------------------------------------------------
 *
 * This event is fired whenever a variant is added to the cart through a form selector (product page, quick
 * view...). This event DOES NOT include any change done through the cart on an existing variant. For that,
 * please refer to the "cart:updated" event.
 *
 * Example:
 *
 * document.addEventListener('variant:added', function(event) {
 *   var variant = event.detail.variant; // Get the variant that was added
 * });
 *
 * ------------------------------------------------------------------------------------------------------------
 * BEING NOTIFIED WHEN THE CART CONTENT HAS CHANGED
 * ------------------------------------------------------------------------------------------------------------
 *
 * This event is fired whenever the cart content has changed (if the quantity of a variant has changed, if a variant
 * has been removed, if the note has changed...). This event will also be emitted when a new variant has been
 * added (so you will receive both "variant:added" and "cart:updated"). Contrary to the variant:added event,
 * this event will give you the complete details of the cart.
 *
 * Example:
 *
 * document.addEventListener('cart:updated', function(event) {
 *   var cart = event.detail.cart; // Get the updated content of the cart
 * });
 *
 * ------------------------------------------------------------------------------------------------------------
 * REFRESH THE CART/MINI-CART
 * ------------------------------------------------------------------------------------------------------------
 *
 * If you are adding variants to the cart and would like to instruct the theme to re-render the cart, you cart
 * send the cart:refresh event, as shown below:
 *
 * document.documentElement.dispatchEvent(new CustomEvent('cart:refresh', {
 *   bubbles: true
 * }));
 *
 * ------------------------------------------------------------------------------------------------------------
 * USAGE OF CUSTOM ELEMENTS
 * ------------------------------------------------------------------------------------------------------------
 *
 * Our theme makes extensive use of HTML custom elements. Custom elements are an awesome way to extend HTML
 * by creating new elements that carry their own JavaScript for adding new behavior. The theme uses a large
 * number of custom elements, but the two most useful are drawer and popover. Each of those components add
 * a "open" attribute that you can toggle on and off. For instance, let's say you would like to open the cart
 * drawer, whose id is "mini-cart", you simply need to retrieve it and set its "open" attribute to true (or
 * false to close it):
 *
 * document.getElementById('mini-cart').open = true;
 *
 * Thanks to the power of custom elements, the theme will take care automagically of trapping focus, maintaining
 * proper accessibility attributes...
 *
 * If you would like to create your own drawer, you can re-use the <drawer-content> content. Here is a simple
 * example:
 *
 * // Make sure you add "aria-controls", "aria-expanded" and "is" HTML attributes to your button:
 * <button type="button" is="toggle-button" aria-controls="id-of-drawer" aria-expanded="false">Open drawer</button>
 *
 * <drawer-content id="id-of-drawer">
 *   Your content
 * </drawer-content>
 *
 * The nice thing with custom elements is that you do not actually need to instantiate JavaScript yourself: this
 * is done automatically as soon as the element is inserted to the DOM.
 *
 * ------------------------------------------------------------------------------------------------------------
 * THEME DEPENDENCIES
 * ------------------------------------------------------------------------------------------------------------
 *
 * While the theme tries to keep outside dependencies as small as possible, the theme still uses third-party code
 * to power some of its features. Here is the list of all dependencies:
 *
 * "vendor.js":
 *
 * The vendor.js contains required dependencies. This file is loaded in parallel of the theme file.
 *
 * - custom-elements polyfill (used for built-in elements on Safari - v1.0.0): https://github.com/ungap/custom-elements
 * - web-animations-polyfill (used for polyfilling WebAnimations on Safari 12, this polyfill will be removed in 1 year - v2.3.2): https://github.com/web-animations/web-animations-js
 * - instant-page (v5.1.0): https://github.com/instantpage/instant.page
 * - tocca (v2.0.9); https://github.com/GianlucaGuarini/Tocca.js/
 * - seamless-scroll-polyfill (v2.0.0): https://github.com/magic-akari/seamless-scroll-polyfill
 *
 * "flickity.js": v2.2.0 (with the "fade" package). Flickity is only loaded on demand if there is a product image
 * carousel on the page. Otherwise it is not loaded.
 *
 * "photoswipe": v4.1.3. PhotoSwipe is only loaded on demand to power the zoom feature on product page. If the zoom
 * feature is disabled, then this script is never loaded.
 */

function closeProductAccordions(x) {
    if (x.matches) {
        // If media query matches
        const accordionsButtons = document.querySelectorAll(
            ".shopify-section--product-columns .collapsible-toggle"
        );
        const accordionsContent = document.querySelectorAll(
            ".shopify-section--product-columns collapsible-content"
        );

        accordionsButtons.forEach((button, index) => {
            button.setAttribute("aria-expanded", false);
        });

        accordionsContent.forEach((content, index) => {
            content.open = false;
        });
    } else {
        const accordionsButtons = document.querySelectorAll(
            ".shopify-section--product-columns .collapsible-toggle"
        );
        const accordionsContent = document.querySelectorAll(
            ".shopify-section--product-columns collapsible-content"
        );

        accordionsButtons.forEach((button, index) => {
            button.setAttribute("aria-expanded", true);
        });

        accordionsContent.forEach((content, index) => {
            content.open = true;
        });
    }
}

var query = window.matchMedia("(max-width: 999px)");
closeProductAccordions(query); // Call listener function at run time
query.addListener(closeProductAccordions); // Attach listener function on state changes

$(document).ready(function () {

    
    $("body").on("click touch", "a[data-subscription-info-open]", function (e) {
        e.preventDefault();

        $(this)
            .closest(".product-anchor")
            .find(".subscription-information")
            .addClass("active");

        $("body").css("overflow", "hidden");
    });

    $("body").on("click touch", "a[data-subscription-open]", function (e) {
        e.preventDefault();
        var typeOfProduct = "";
        var quantity = 1;

        if (
            $(this)
                .closest(".product-anchor")
                .find(".recharge__container")
                .hasClass("main")
        ) {
            typeOfProduct = "main";
        } else {
            typeOfProduct = "grid";
        }

        // console.log(typeOfProduct);

        // Hide all containers
        $(".add-to-cart-confirmation-container").removeClass("active");

        // Show the correct one
        $(this)
            .closest(".product-anchor")
            .find(".add-to-cart-confirmation-container")
            .addClass("active");

        // Update quantity
        if (typeOfProduct == "grid") {
            quantity = $(this)
                .closest(".product-anchor")
                .find(".quantity-selector__input")
                .val();
        } else {
            quantity = $(this)
                .closest(".product-anchor")
                .find(".quantity-selector__input")
                .val();
        }

        $(this)
            .closest(".product-anchor")
            .find(".recharge__container")
            .find("form input[name=quantity]")
            .val(quantity);

        $("body").css("overflow", "hidden");
    });

    $("body").on("change", ".subscription__interval-checkbox", function (e) {
        e.preventDefault();
        var value = $(this).val();
        var target = $(this).data("target");
        $(target).val(value);
    });

    $("body").on(
        "click touch",
        ".add-to-cart-confirmation-close",
        function (e) {
            e.preventDefault();
            $(".add-to-cart-confirmation-container").removeClass("active");

            $("body").css("overflow", "initial");
        }
    );

    $("body").on(
        "click touch",
        ".subscription-information-close",
        function (e) {
            e.preventDefault();
            $(".subscription-information").removeClass("active");

            $("body").css("overflow", "initial");
        }
    );

    // Collection image on menu

    /*var mainImage = $(".mega-menu__image-preview img").attr("src");

    $(".linklist__item a").on("mouseenter", function (e) {
        e.preventDefault();

        var collectionImage = $(this).data("collection-image");

        $(".mega-menu__image-preview img").attr("src", collectionImage);
    });

    $(".linklist__item a").on("mouseleave", function (e) {
        e.preventDefault();

        $(".mega-menu__image-preview img").attr("src", mainImage);
    });*/
});

// Hide smile and whatsapp
document.addEventListener("DOMContentLoaded", function () {
    // Create a MutationObserver instance
    var observer = new MutationObserver(function (mutationsList, observer) {
        for (var mutation of mutationsList) {
            // Check if the injected elements are added to the document
            if (
                mutation.type === "childList" &&
                (document.getElementById("wa-chat-btn-root") ||
                    document.getElementById("smile-ui-lite-container"))
            ) {
                // Get references to the elements
                var chatBtn = document.getElementById("wa-chat-btn-root");
                var smileContainer = document.getElementById(
                    "smile-ui-lite-container"
                );

                if(chatBtn)
                    chatBtn.style.visibility = "hidden";
                smileContainer.style.visibility = "hidden";

                // Function to handle scroll event
                function handleScroll() {
                    // Check the scroll position
                    var scrollPosition =
                        window.pageYOffset ||
                        document.documentElement.scrollTop;

                    // If scrolled at least 200 pixels, show the elements
                    if (scrollPosition >= 200) {
                        if(chatBtn)
                            chatBtn.style.visibility = "visible";
                        smileContainer.style.visibility = "visible";
                    } else {
                        if(chatBtn)
                            chatBtn.style.visibility = "hidden";
                        smileContainer.style.visibility = "hidden";
                    }
                }

                // Attach scroll event listener
                window.addEventListener("scroll", handleScroll);

                // Hide the elements by default
                if(chatBtn)
                    chatBtn.style.visibility = "hidden";
                smileContainer.style.visibility = "hidden";

                // Check the initial scroll position
                handleScroll();

                // Disconnect the MutationObserver since it's no longer needed
                observer.disconnect();
                break;
            }
        }
    });

    // Observe changes in the document's body
    observer.observe(document.body, { childList: true, subtree: true });
});

// External links _blank

// Get all anchor elements on the page
const anchors = document.getElementsByTagName("a");

// Loop through each anchor element
for (let i = 0; i < anchors.length; i++) {
    const anchor = anchors[i];

    // Check if the anchor's href starts with "http://" or "https://" and does not contain the current domain
    if (
        anchor.href.startsWith("http://") ||
        anchor.href.startsWith("https://")
    ) {
        const currentDomain = window.location.hostname;

        if (!anchor.href.includes(currentDomain)) {
            // Add target="_blank" to the anchor element
            anchor.setAttribute("target", "_blank");
        }
    }
}
